<div class="locations">
    <app-interview-loc *ngFor="let location of locations" [location]="location" [interviewerId]="interviewerId" [activeCount]="activeCount" (locationSelected)="onLocationSelected($event)" (locationDetailsChanged)="onLocationDetailsChanged($event)"></app-interview-loc>
</div>
